import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/shared/services/storage.service';
import * as uuid from 'uuid';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiHeaderService {
  public deviceMetaInfo;
  public server = environment.APIEndpoint;
  public appversion;
  constructor(private storageService:StorageService) {
    if (this.server === 'https://tsb-sit-api.reciproci.com/') {
      this.appversion = '0.0.77'
    }else if(this.server === 'https://tsb-mbaas-uat.starbucksindia.net/'){
      this.appversion = '0.0.77'
    }else{
      this.appversion = '5.0.4'
    }
  }
  getSecureHeader(){
    if(localStorage.getItem("deviceId") == null){
      localStorage.setItem('deviceId', uuid.v4());
    }
    this.deviceMetaInfo = {
      "appVersion": this.appversion,
      "deviceCountry": "India",
      "deviceCity": "",
      "deviceId": localStorage.getItem("deviceId"),
      "deviceModel": "",
      "platform": "KIOSK",
      "deviceOSVersion": ""
    };
    let secHeaders = {
      'Accept-Language': 'EN',
      'Authorization': 'Bearer' + ' ' +  this.storageService.getAccessToken(),
      'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo)
    }
    return secHeaders;
  }
  getUnSecureHeader(){
    if(localStorage.getItem("deviceId") == null){
      localStorage.setItem('deviceId', uuid.v4());
    }
    this.deviceMetaInfo = {
      "appVersion": this.appversion,
      "deviceCountry": "India",
      "deviceCity": "",
      "deviceId": localStorage.getItem("deviceId"),
      "deviceModel": "",
      "platform": "KIOSK",
      "deviceOSVersion": ""
    };
    let unsecureHeaders = {
      'Accept-Language': 'EN',
      'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo),
      'GuestToken': localStorage.getItem('guestUserToken'),
    }
    return unsecureHeaders;
  }
  getUnSecureHeaderWithoutGuestToken(){
    if(localStorage.getItem("deviceId") == null){
      localStorage.setItem('deviceId', uuid.v4());
    }
    this.deviceMetaInfo = {
      "appVersion": this.appversion,
      "deviceCountry": "India",
      "deviceCity": "",
      "deviceId": localStorage.getItem("deviceId"),
      "deviceModel": "",
      "platform": "KIOSK",
      "deviceOSVersion": ""
    };
    let unsecureHeaders = {
      'Accept-Language': 'EN',
      'Device-Meta-Info': JSON.stringify(this.deviceMetaInfo),
    }
    return unsecureHeaders;
  }
}
